<button [class.input-error]="isError">
    <div class="option-labels">
        <span class="paragraph-small">{{ inputLabel }}</span>
        @if ( inputValue ) {
        <span class="paragraph-medium">
            {{ inputValue }}
        </span>
        }
    </div>
    <h-svg-icon [name]="'arrow-right-bold'"></h-svg-icon>
</button>
